import React from "react";

function Button(props) {
  let { name, type, onClick, customStyle, disabled } = props;
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={`px-6 py-3 bg-[#007E8B] text-white font-bold text-lg leading-normal capitalize rounded shadow-md hover:bg-[#387171] hover:shadow-lg transition duration-150 ease-in-out ${customStyle}`}
    >
      {name}
    </button>
  );
}

export default Button;
